import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import v3Image from "../../assets/DoorAccess/g3-starter-kit.jpg";
import image from "../../assets/product-list-assets/cameras/door-access/g3-starter-kit.jpg";
import type { Product } from "../../types";
import { starterKits } from "../product-list-groups/starterKits";
import {
  includedAccessories,
  includedHub,
  includedReaders,
  touchPassSupport,
} from "../properties";

export const g3StarterKit: Product = {
  id: "g3StarterKit",
  productTitle: "G3 Starter Kit",
  description: "g3StarterKit.description",
  productListGroup: starterKits,
  descriptionMaxWidth: 220,
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.DoorAccess}/ua-g3-sk`,
  ],
  storePathParts: {
    category: UniFiChildCategorySlug.DoorAccessStarterKit,
    productSlug: "ua-g3-sk",
  },
  image: { src: image, width: 200, height: 160 },
  v3Image: {
    src: v3Image,
    width: 327,
    height: 182,
  },
  isNew: true,
  propertyValues: [
    {
      propertyId: includedHub.id,
      value: {
        type: "translation",
        value: "g3StarterKit.includedHub",
      },
    },
    {
      propertyId: includedReaders.id,
      value: {
        type: "translation",
        value: "g3StarterKit.includedReaders",
      },
    },
    {
      propertyId: includedAccessories.id,
      value: {
        type: "translation",
        value: "g3StarterKit.includedAccessories",
      },
    },
    {
      propertyId: touchPassSupport.id,
      value: {
        type: "string",
        value: "Apple Wallet\nGoogle Wallet",
      },
    },
  ],
};
